export class ContentFooterColumn {
  id: any;
  tabcolheading: any;
  tabcolitem: ContentFooterColumnItem[];

  constructor(itemId: any, content?: any) {
    if (content) {
      this.id = itemId;
      if (content['tabcolheading']) {
        this.tabcolheading = content['tabcolheading'];
      }
      if (content['tabcolItems']) {
        this.tabcolitem = this.fillTabItem(content['tabcolItems']);
      }
    }
  }

  private fillTabItem(content?: any): ContentFooterColumnItem[] {
    let tabItem: ContentFooterColumnItem[] = [];
    const tabItems = new Map();
    if (content) {
      const keys = Object.keys(content);
      const values = keys.map((key) => content[key]);
      let counter = 1;
      for (const value of values) {
        tabItems.set(counter, new ContentFooterColumnItem(counter, value));
        counter++;
      }
      tabItem = Array.from(tabItems.values());
    }
    return tabItem;
  }
}

export class ContentFooterColumnItem {
  id: any;
  tabnewwindow: any;
  tabitemtext: any;
  tabitemUrl: any;
  externalimage: any;

  constructor(itemId: any, content?: any) {
    if (content) {
      this.id = itemId;
      if (content['tabnewwindow']) {
        this.tabnewwindow = content['tabnewwindow'];
      } else {
        this.tabnewwindow = '';
      }
      if (content['tabitemtext']) {
        this.tabitemtext = content['tabitemtext'];
      } else {
        this.tabitemtext = '';
      }
      if (content['tabitemUrl']) {
        this.tabitemUrl = content['tabitemUrl'];
      } else {
        this.tabitemUrl = '';
      }
      if (content['externalimage']) {
        this.externalimage = content['externalimage'];
      } else {
        this.externalimage = '';
      }
    }
  }
}
